import React from "react";

import { Frame } from "@bitesite/react-figstrap";
import { Text } from "../../odc-ui";

import Prepaid1000WithGiftImage from "../../../assets/images/prepaid-cards/prepaid-1000-with-gift.png";
import Prepaid2000WithGiftImage from "../../../assets/images/prepaid-cards/prepaid-2000-with-gift.png";
import Prepaid3000WithGiftImage from "../../../assets/images/prepaid-cards/prepaid-3000-with-gift.png";
import Prepaid4000WithGiftImage from "../../../assets/images/prepaid-cards/prepaid-4000-with-gift.png";
import Prepaid5000WithGiftImage from "../../../assets/images/prepaid-cards/prepaid-5000-with-gift.png";
import Prepaid6000WithGiftImage from "../../../assets/images/prepaid-cards/prepaid-6000-with-gift.png";
import Prepaid8000WithGiftImage from "../../../assets/images/prepaid-cards/prepaid-8000-with-gift.png";
import Prepaid10000WithGiftImage from "../../../assets/images/prepaid-cards/prepaid-10000-with-gift.png";

import Prepaid1000Image from "../../../assets/images/prepaid-cards/prepaid-1000.png";
import Prepaid5000Image from "../../../assets/images/prepaid-cards/prepaid-5000.png";
import Prepaid7500Image from "../../../assets/images/prepaid-cards/prepaid-7500.png";
import Prepaid10000Image from "../../../assets/images/prepaid-cards/prepaid-10000.png";
import Prepaid15000Image from "../../../assets/images/prepaid-cards/prepaid-15000.png";
import Prepaid20000Image from "../../../assets/images/prepaid-cards/prepaid-20000.png";
import Prepaid25000Image from "../../../assets/images/prepaid-cards/prepaid-25000.png";
import Prepaid30000Image from "../../../assets/images/prepaid-cards/prepaid-30000.png";

const dermatologyPrepaidSlideContents = [
  {
    image: Prepaid1000WithGiftImage,
  },
  {
    image: Prepaid2000WithGiftImage,
  },
  {
    image: Prepaid3000WithGiftImage,
  },
  {
    image: Prepaid4000WithGiftImage,
  },
  {
    image: Prepaid5000WithGiftImage,
  },
  {
    image: Prepaid6000WithGiftImage,
  },
  {
    image: Prepaid8000WithGiftImage,
  },
  {
    image: Prepaid10000WithGiftImage,
  },
];

const dermatologyPrepaidWriteupContents = [
  {
    writeupText: (
      <Frame vertical gap={12}>
        <Text type="regular-medium">
          Invest in $1000 Healthcoin<sup>®</sup> Prepaid and get $50 instant
          top-up. Earn 8% annual rewards on available balance.
        </Text>
        <div>
          Plus, enjoy a <Text type="regular-bold">FREE Vivier gift</Text> up to
          $75 value.
        </div>
      </Frame>
    ),
    buyNowUrl: "/users/sign_up",
  },
  {
    writeupText: (
      <Frame vertical gap={12}>
        <Text type="regular-medium">
          Invest in $2000 Healthcoin<sup>®</sup> Prepaid and get $100 instant
          top-up. Earn 8% annual rewards on available balance.
        </Text>
        <div>
          Plus, enjoy <Text type="regular-bold">FREE Botox (10 units)</Text> up
          to $130 value.
        </div>
      </Frame>
    ),
    buyNowUrl: "/users/sign_up",
  },
  {
    writeupText: (
      <Frame vertical gap={12}>
        <Text type="regular-medium">
          Invest in $3000 Healthcoin<sup>®</sup> Prepaid and get $150 instant
          top-up. Earn 8% annual rewards on available balance.
        </Text>
        <div>
          Plus, enjoy a <Text type="regular-bold">FREE BBL Face Treatment</Text>{" "}
          of $500 value.
        </div>
      </Frame>
    ),
    buyNowUrl: "/users/sign_up",
  },
  {
    writeupText: (
      <Frame vertical gap={12}>
        <Text type="regular-medium">
          Invest in $4000 Healthcoin<sup>®</sup> Prepaid and get $200 instant
          top-up. Earn 8% annual rewards on available balance.
        </Text>
        <div>
          Plus, enjoy a{" "}
          <Text type="regular-bold">FREE BBL Face & Neck Treatment</Text> of
          $750 value.
        </div>
      </Frame>
    ),
    buyNowUrl: "/users/sign_up",
  },
  {
    writeupText: (
      <Frame vertical gap={12}>
        <Text type="regular-medium">
          Invest in $5000 Healthcoin<sup>®</sup> Prepaid and get $250 instant
          top-up. Earn 8% annual rewards on available balance.
        </Text>
        <div>
          Plus, enjoy a <Text type="regular-bold">FREE Syringe of Filler</Text>{" "}
          up to $800 value.
        </div>
      </Frame>
    ),
    buyNowUrl: "/users/sign_up",
  },
  {
    writeupText: (
      <Frame vertical gap={12}>
        <Text type="regular-medium">
          Invest in $6000 Healthcoin<sup>®</sup> Prepaid and get $300 instant
          top-up. Earn 8% annual rewards on available balance.
        </Text>
        <div>
          Plus, enjoy a{" "}
          <Text type="regular-bold">FREE Pico Rejuvenation Treatment</Text> of
          $1,000 value.
        </div>
      </Frame>
    ),
    buyNowUrl: "/users/sign_up",
  },
  {
    writeupText: (
      <Frame vertical gap={12}>
        <Text type="regular-medium">
          Invest in $8000 Healthcoin<sup>®</sup> Prepaid and get $400 instant
          top-up. Earn 8% annual rewards on available balance.
        </Text>
        <div>
          Plus, enjoy a{" "}
          <Text type="regular-bold">FREE Halo Face Treatment</Text> of $1,500
          value.
        </div>
      </Frame>
    ),
    buyNowUrl: "/users/sign_up",
  },
  {
    writeupText: (
      <Frame vertical gap={12}>
        <Text type="regular-medium">
          Invest in $10,000 Healthcoin<sup>®</sup> Prepaid and get $500 instant
          top-up. Earn 8% annual rewards on available balance.
        </Text>
        <div>
          Plus, enjoy a <Text type="regular-bold">FREE Thermage Treatment</Text>{" "}
          of $2,500 value.
        </div>
      </Frame>
    ),
    buyNowUrl: "/users/sign_up",
  },
];

const surgeryPrepaidSlideContents = [
  {
    image: Prepaid1000Image,
  },
  {
    image: Prepaid5000Image,
  },
  {
    image: Prepaid7500Image,
  },
  {
    image: Prepaid10000Image,
  },
  {
    image: Prepaid15000Image,
  },
  {
    image: Prepaid20000Image,
  },
  {
    image: Prepaid25000Image,
  },
  {
    image: Prepaid30000Image,
  },
];

const surgeryPrepaidWriteupContents = [
  {
    writeupText: (
      <Frame vertical gap={12}>
        <Text type="regular-medium">
          Invest in $1000 Healthcoin<sup>®</sup> Prepaid and get $50 instant
          top-up. Earn 8% annual rewards on available balance.
        </Text>
      </Frame>
    ),
    buyNowUrl: "/users/sign_up",
  },
  {
    writeupText: (
      <Frame vertical gap={12}>
        <Text type="regular-medium">
          Invest in $5000 Healthcoin<sup>®</sup> Prepaid and get $250 instant
          top-up. Earn 8% annual rewards on available balance.
        </Text>
      </Frame>
    ),
    buyNowUrl: "/users/sign_up",
  },
  {
    writeupText: (
      <Frame vertical gap={12}>
        <Text type="regular-medium">
          Invest in $7500 Healthcoin<sup>®</sup> Prepaid and get $375 instant
          top-up. Earn 8% annual rewards on available balance.
        </Text>
      </Frame>
    ),
    buyNowUrl: "/users/sign_up",
  },
  {
    writeupText: (
      <Frame vertical gap={12}>
        <Text type="regular-medium">
          Invest in $10,000 Healthcoin<sup>®</sup> Prepaid and get $500 instant
          top-up. Earn 8% annual rewards on available balance.
        </Text>
      </Frame>
    ),
    buyNowUrl: "/users/sign_up",
  },
  {
    writeupText: (
      <Frame vertical gap={12}>
        <Text type="regular-medium">
          Invest in $15,000 Healthcoin<sup>®</sup> Prepaid and get $750 instant
          top-up. Earn 8% annual rewards on available balance.
        </Text>
      </Frame>
    ),
    buyNowUrl: "/users/sign_up",
  },
  {
    writeupText: (
      <Frame vertical gap={12}>
        <Text type="regular-medium">
          Invest in $20,000 Healthcoin<sup>®</sup> Prepaid and get $1,000
          instant top-up. Earn 8% annual rewards on available balance.
        </Text>
      </Frame>
    ),
    buyNowUrl: "/users/sign_up",
  },
  {
    writeupText: (
      <Frame vertical gap={12}>
        <Text type="regular-medium">
          Invest in $25,000 Healthcoin<sup>®</sup> Prepaid and get $1,250
          instant top-up. Earn 8% annual rewards on available balance.
        </Text>
      </Frame>
    ),
    buyNowUrl: "/users/sign_up",
  },
  {
    writeupText: (
      <Frame vertical gap={12}>
        <Text type="regular-medium">
          Invest in $30,000 Healthcoin<sup>®</sup> Prepaid and get $1,500
          instant top-up. Earn 8% annual rewards on available balance.
        </Text>
      </Frame>
    ),
    buyNowUrl: "/users/sign_up",
  },
];

export {
  dermatologyPrepaidSlideContents,
  dermatologyPrepaidWriteupContents,
  surgeryPrepaidSlideContents,
  surgeryPrepaidWriteupContents,
};
